<p-button label="Call Agent" (click)="callAgent()" />
<div class="info-content">
  <p-divider>Score</p-divider>

  <label for="slider">Current Score : {{ evaluationService.scoreSignal() }}</label>

  <div class="flex flex gap-3">
    <p-slider [(ngModel)]="value" [step]="10" class="w-56" />
    <p-button label="Set Score to {{ value }}" (onClick)="setScore()" />
  </div>

  <p-divider>Conversation Flow</p-divider>
  <div class="mb-2">
    <div class="flex items-center gap-2">
      @if (dynamicFlowService.conversationFlowState()?.goal?.enabled) {
      <div class="w-3 h-3 bg-green-500 rounded-full" pTooltip="Active"></div>
      } @else {
      <div class="w-3 h-3 bg-red-500 rounded-full" pTooltip="Inactive"></div>
      }
      <p class="font-semibold">Goal</p>
    </div>
    @if(dynamicFlowService.conversationFlowState()?.goal?.task; as task) {
    <div class="pl-5 mt-1 text-sm text-gray-600 italic"> {{ task }} </div>
    }
  </div>

  <div class="mb-2">
    <div class="flex items-center gap-2">
      @if (dynamicFlowService.conversationFlowState()?.triggerTasks?.onUserMessage?.enabled) {
      <div class="w-3 h-3 bg-green-500 rounded-full" pTooltip="Active"></div>
      } @else {
      <div class="w-3 h-3 bg-red-500 rounded-full" pTooltip="Inactive"></div>
      }
      <p class="font-semibold">Trigger User Message</p>
    </div>
    @if(dynamicFlowService.conversationFlowState()?.triggerTasks?.onUserMessage?.task; as task) {
    <div class="pl-5 mt-1 text-sm text-gray-600 italic"> {{ task }} </div>
    }
  </div>

  <div class="mb-2">
    <div class="flex items-center gap-2">
      @if (dynamicFlowService.conversationFlowState()?.triggerTasks?.onAssistantMessage?.enabled) {
      <div class="w-3 h-3 bg-green-500 rounded-full" pTooltip="Active"></div>
      } @else {
      <div class="w-3 h-3 bg-red-500 rounded-full" pTooltip="Inactive"></div>
      }
      <p class="font-semibold">Trigger Assistant Message</p>
    </div>
    @if(dynamicFlowService.conversationFlowState()?.triggerTasks?.onAssistantMessage?.task; as task) {
    <div class="pl-5 mt-1 text-sm text-gray-600 italic"> {{ task }} </div>
    }
  </div>

  <h3>Herramientas</h3>
  @for (tool of dynamicFlowService.conversationFlowState()?.tools; track tool.name) {
  <div class="mb-2">
    <div class="flex items-center gap-2">
      @if (tool.enabled) {
      <div class="w-3 h-3 bg-green-500 rounded-full" pTooltip="Active"></div>
      } @else {
      <div class="w-3 h-3 bg-red-500 rounded-full" pTooltip="Inactive"></div>
      }
      <p class="font-semibold">{{ tool.name }}</p>
    </div>
    @if(tool.description) {
    <div class="pl-5 mt-1 text-sm text-gray-600 italic"> {{ tool.description }} </div>
    }
  </div>
  }

  <h3>Challenges Retos</h3>
  @for (challenge of dynamicFlowService.conversationFlowState()?.challenges; track challenge.name) {
  <div class="mb-2">
    <div class="flex items-center gap-2">
      @if (challenge.enabled) {
      <div class="w-3 h-3 bg-green-500 rounded-full" pTooltip="Active"></div>
      } @else {
      <div class="w-3 h-3 bg-red-500 rounded-full" pTooltip="Inactive"></div>
      }

      <p class="font-semibold"> {{ challenge.emoji }} {{ challenge.name }}</p>
    </div>
    @if(challenge.description) {
    <div class="pl-5 mt-1 text-sm text-gray-600 italic"> {{ challenge.description }} </div>
    }
  </div>
  }
  <h5>Conditions</h5>

  @for (condition of dynamicFlowService.conversationFlowState()?.dynamicConditions; track $index) {
  <div class="pl-2 mt-1 text-sm text-gray-600 italic"> When the {{ condition.what }} is {{ condition.when }} than {{ condition.value }} Do </div>
  <ol>
    @for (doAction of condition.do; track $index) {
    <li class="pl-5 mt-1 text-sm text-gray-600 italic">
      {{ $index }})
      <span style="color: brown"> {{ doAction.actionType }}</span>
      <span style="color: green"> {{ doAction.systemPromptType }}</span>
      <span style="color: green"> {{ doAction.dynamicFlowTaskType }}</span>

      to
      <span style="color: rgb(49, 23, 177)"> {{ doAction.enabled }}</span>
      "{{ doAction.prompt }}"
    </li>
    }
  </ol>
  }

  <p>Challenges</p>
  <pre>{{ dynamicFlowService.conversationFlowState()?.challenges | safeJson }}</pre>

  <details>
    <summary>Messages</summary>
    <div>
      <p-button label="Exportar todo" (click)="exportChat('all')" />
      <p-button label="Exportar conversación" (click)="exportChat('conversation')" />
    </div>
    @for (message of messageStateService.getMessagesSignal()(); track message.messageId) {
    <h6>
      @if (message.role === 'system') {
      <b class="text-red-500" style="text-transform: capitalize">{{ message.role }}</b> - } @else {
      <b style="text-transform: capitalize">{{ message.role }}</b> - }
      <b style="color: var(--info-color); text-transform: capitalize">{{ message.messageId }}</b></h6
    >
    <p>{{ message.content }}</p>
    }
  </details>

  <details>
    <summary>Conversation Flow</summary>
    <p>Goal</p>
    <pre>{{ dynamicFlowService.conversationFlowState()?.goal | safeJson }}</pre>
    <p>Trigger User Message</p>
    <pre>{{ dynamicFlowService.conversationFlowState()?.triggerTasks?.onUserMessage | safeJson }}</pre>
    <p>Trigger Assistant Message</p>
    <pre>{{ dynamicFlowService.conversationFlowState()?.triggerTasks?.onAssistantMessage | safeJson }}</pre>
    <p>Conditions</p>
    <pre>{{ dynamicFlowService.conversationFlowState()?.dynamicConditions | safeJson }}</pre>
    <p>Tools</p>
    <pre>{{ dynamicFlowService.conversationFlowState()?.tools | safeJson }}</pre>
    <p>Challenges</p>
    <pre>{{ dynamicFlowService.conversationFlowState()?.challenges | safeJson }}</pre>
  </details>

  <details>
    <summary>Agent Card</summary>
    <pre>{{ agentCard | safeJson }}</pre>
  </details>

  <details>
    <summary>User Settings</summary>
    <pre>{{ chatUserSettings | safeJson }}</pre>
  </details>
</div>
